import classNames from "classnames";
import { Logger } from "~/utils/logger";
const logger = new Logger("ProfileImage", "info");

export const ProfileImage = ({
  title,
  imageUrl,
}: {
  title: string;
  imageUrl: string;
}) => {
  logger.debug("props:", { title, imageUrl });

  // placeholder image if no imageUrl provided
  if (!imageUrl) {
    return (
      <div
        className={classNames(
          "tw:overflow-hidden tw:rounded-[20px] tw:w-[200px] tw:h-[200px]",
          "tw:!shadow-gray-100 tw:!shadow-sm tw:bg-gradient-to-r tw:from-gray-100 tw:to-gray-50",
        )}
      >
        <div className="tw:overflow-hidden tw:rounded-[20px] tw:w-[200px] tw:h-[200px]" />
      </div>
    );
  }

  return (
    <div className="tw:overflow-hidden tw:rounded-[20px] tw:w-[200px] tw:h-[200px] tw:!shadow-gray-100 tw:!shadow-sm">
      <img
        src={imageUrl}
        alt={title}
        className="tw:overflow-hidden tw:object-cover tw:object-center tw:rounded-[20px] tw:!h-full tw:!w-full"
      />
    </div>
  );
};
